module.exports = __webpack_public_path__ + "static/scale-model-of-maryland-science-center-in-baltimore-maryland-677738f053b3f8f080c1ca828f5ae527.png";